import { Component, input, output } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';
import { LvrPaddingDirective } from '../../../shared/padding/padding.directive';
import { LvrButton } from '../lvr-button/lvr-button';

@Component({
	selector: 'lvr-heading',
	templateUrl: './heading.html',
	styleUrl: './heading.scss',
	imports: [LvrPaddingDirective, TranslocoPipe, MatTooltip, LvrButton],
})
export class LvrHeading {
	public readonly showEditButton = input<boolean>(false);
	public readonly showDeleteButton = input<boolean>(false);
	public readonly editClicked = output<void>();
	public readonly deleteClicked = output<void>();

	public readonly disableEditButton = input<boolean>(false);
	public readonly disableDeleteButton = input<boolean>(false);

	public readonly deleteTranslationKey = input<string>('base.button.delete');

	public readonly disableEditTranslationKey = input<string>('base.button.edit_disabled');
	public readonly disableDeleteTranslationKey = input<string>('base.button.delete_disabled');

	public readonly disableEditTranslationParams = input<Record<string, unknown> | undefined>(undefined);
	public readonly disableDeleteTranslationParams = input<Record<string, unknown> | undefined>(undefined);

	public getEditTooltip() {
		if (this.disableEditButton()) {
			return this.disableEditTranslationKey();
		}

		return undefined;
	}

	public getEditTooltipParams() {
		if (this.disableEditButton()) {
			return this.disableEditTranslationParams();
		}

		return undefined;
	}

	public getDeleteTooltip() {
		if (this.disableDeleteButton()) {
			return this.disableDeleteTranslationKey();
		}

		return undefined;
	}

	public getDeleteTooltipParams() {
		if (this.disableDeleteButton()) {
			return this.disableDeleteTranslationParams();
		}

		return undefined;
	}
}
